import React from 'react'
import { CSSTransition } from 'react-transition-group'
import cx from 'classnames'

import styles from './FadeScale.module.scss'

export const FadeScale = React.forwardRef(
  (
    {
      children,
      className = undefined,
      timeout = { enter: 500, exit: 0 },
      isInitialised,
    },
    ref,
  ) => (
    <CSSTransition
      className={cx({ [className]: Boolean(className) })}
      classNames={{
        enter: styles.enter,
        enterActive: styles.enterActive,
        exit: styles.exit,
        exitActive: styles.exitActive,
      }}
      nodeRef={ref}
      timeout={timeout}
      in={isInitialised}
      mountOnEnter
      unmountOnExit
    >
      {children}
    </CSSTransition>
  ),
)
